import {retrieveItem, clearItem} from './Storage';
import Strings from '../Constants/Strings';
import Endpoints from '../Constants/Endpoints';
import {promptReason} from './reasonPrompt';

const BASE_URL = Endpoints.SERVER_HOST + Endpoints.API_URL;

const LOGIN_PATH = (process.env.PUBLIC_URL || '') + '/';

// Any 401 means the token/session is no longer valid (expired or revoked).
// Clear the stored auth and send the user back to login. A hard navigation
// resets in-memory global state on reload.
const handleSessionExpired = () => {
    clearItem('user');
    clearItem('token');
    if (window.location.pathname !== LOGIN_PATH) {
        window.location.assign(LOGIN_PATH);
    }
};

let headers = new Headers();


let getDeviceName = () => {
    let ua = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i),
        browser;

    if (navigator.userAgent.match(/Edge/i) || navigator.userAgent.match(/Trident.*rv[ :]*11\./i)) {
        browser = "msie";
    } else {
        browser = ua[1].toLowerCase();
    }
    return browser;
};


let buildHeaders = () => {
    resetHeaders();

    const item = retrieveItem('token');

    if (item != null) {
        headers.append('Authorization', `Bearer ${item}`);
    }

    headers.append('app_id', Strings.APP_ID);
    headers.append('device_id', navigator.appVersion);
    headers.append('device_name', getDeviceName());
    headers.append('Accept-Encoding', 'br');

    console.log(headers);

    return true;
};

let resetHeaders = () => {
    headers.delete('Authorization');
    headers.delete('app_id');
    headers.delete('device_id');
    headers.delete('device_name');
    headers.delete('content-type');
};

export const getFileUrl = fileName => Endpoints.SERVER_HOST + Endpoints.FILE_URL + fileName;

export let fetchData = async (endPoint) => {
    const url = BASE_URL + endPoint;

    console.log(`Fetching from ${url}`);

    await buildHeaders();

    console.log(headers);

    const response = await fetch(url, {method: 'GET', headers: headers});
    if (response.status === 401) {
        handleSessionExpired();
    }
    return response;

};

export let postData = async (endPoint, data) => {
    const url = BASE_URL + endPoint;

    console.log(`Fetching from ${url}`);

    console.log(data);

    buildHeaders();

    // if (endPoint === Endpoints.UPLOAD) {
    //     headers.append('content-type', 'multipart/form-data')
    // }

    console.log(headers);

    let response = await fetch(url, {method: 'POST', headers: headers, body: data});

    // Expired / revoked session — clear auth and redirect to login.
    if (response.status === 401) {
        handleSessionExpired();
        return response;
    }

    // Central audit-reason handling: audited endpoints reject with 400
    // {"error":"reason required"} when no reason is supplied. Prompt once and
    // retry with the reason attached — this covers every audited action without
    // per-flow wiring. Only FormData bodies can carry an appended reason.
    if (data instanceof FormData) {
        let peek = null;
        try {
            peek = await response.clone().json();
        } catch (e) {
            peek = null;
        }
        if (peek && peek.error === 'reason required') {
            const reason = await promptReason({title: 'Reason required for this action'});
            if (reason) {
                data.append('reason', reason);
                buildHeaders();
                response = await fetch(url, {method: 'POST', headers: headers, body: data});
            }
        }
    }

    return response;
};

export const getQueryVariable = variable => {
    let query = window.location.search.substring(1);

    let vars = query.split("&");

    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        console.log(pair)
        if (pair[0] === variable) {
            return pair[1];
        }
    }
    return "";
};

